import React from 'react'
import { STAR_ANGLES, STAR_BURST_DISTANCE, STAR_BURST_DURATION_MS } from './missionCompleteConstants'

interface MissionStarBurstProps {
  burstKey: number
  visible: boolean
}

export const MissionStarBurst: React.FC<MissionStarBurstProps> = ({ burstKey, visible }) => {
  if (!visible) return null
  return (
    <>
      <div
        key={burstKey}
        className="absolute inset-0 z-20 overflow-visible flex items-center justify-center pointer-events-none"
        style={{ margin: '-25%' }}
        aria-hidden
      >
        {STAR_ANGLES.map((angle, i) => (
          <div
            key={i}
            className="absolute rounded-full mission-star-burst"
            style={{
              width: 14,
              height: 14,
              marginLeft: -7,
              marginTop: -7,
              '--angle': `${angle}deg`,
              '--distance': `${STAR_BURST_DISTANCE}px`,
              '--duration': `${STAR_BURST_DURATION_MS}ms`,
              '--delay': `${i * 14}ms`,
              background:
                'radial-gradient(circle, rgba(255,255,240,0.98) 0%, rgba(255,236,179,0.95) 25%, rgba(255,213,79,0.95) 55%, rgba(245,158,11,0.7) 100%)',
              boxShadow:
                '0 0 10px rgba(255,235,150,0.95), 0 0 24px rgba(255,200,80,0.7), 0 0 40px rgba(245,158,11,0.4)',
              filter: 'blur(0.5px)',
            } as React.CSSProperties}
          />
        ))}
      </div>
      <style>{`
        .mission-star-burst {
          left: 50%;
          top: 50%;
          animation: mission-star-burst-out var(--duration) ease-out var(--delay) forwards;
          opacity: 0;
        }
        @keyframes mission-star-burst-out {
          0% {
            opacity: 1;
            transform: rotate(var(--angle)) translateX(0) scale(0.2);
          }
          12% {
            opacity: 1;
            transform: rotate(var(--angle)) translateX(calc(var(--distance) * 0.15)) scale(1.4);
          }
          100% {
            opacity: 0;
            transform: rotate(var(--angle)) translateX(var(--distance)) scale(0.7);
          }
        }
      `}</style>
    </>
  )
}
